import * as React from 'react'
import type { SvgIconProps } from '@mui/material'
import { BaseIcon } from '../BaseIcon'
export const ClockIcon = (props: SvgIconProps) => (
  <BaseIcon fill="none" {...props}>
    <path
      fill="currentColor"
      d="M11.99 1C18.071 1 23 5.928 23 12s-4.928 11-11.01 11C5.916 23 1 18.072 1 12S5.917 1 11.99 1M12 3.2A8.797 8.797 0 0 0 3.2 12c0 4.862 3.938 8.8 8.8 8.8s8.8-3.938 8.8-8.8-3.938-8.8-8.8-8.8m.55 3.3v5.775l4.95 2.937-.825 1.353L10.9 13.1V6.5z"
    />
  </BaseIcon>
)
